"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinancialServiceComplianceControl = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.FinancialServiceComplianceControl = {
    priority: 1,
    label: 'fields.payload.mor_group_answers.financial_service_compliance_control.label',
    fallbackLabel: 'Do you have targeted compliance controls in place that include specific measures designed to address unique challenges, such as a higher risk of money laundering, in this particular segment? For example, enhanced transaction monitoring and enhanced due diligence measures specific for this industry?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.has_financial_services_segment', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.has_financial_services_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.has_financial_services_segment === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
